// extracted by mini-css-extract-plugin
export default {"root":"sUamHwkvx7_CZoDRM4Ks","column":"nhT4RUxnMterfov63QT0","placeHolderShimmer":"auYot3958c9kR01XUzEw"};